import styled from "styled-components";

export const FilterContainer = styled.div`
  min-width: 340px;
  grid-area: fltr;
`

export const TreeContainer = styled.div`
  background: #fff;

  .ant-tree .ant-tree-switcher-noop {
    display: none;
  }
`

export const FilterLabel = styled.span`
  display: block;
  margin: 5px 0;
  font-size: 18px;
  font-weight: 700;
`
export const FilterButton = styled.button<{ outline?: boolean }>`
  //font-family: 'FuturaPT', sans-serif;
  -webkit-tap-highlight-color: white;
  box-sizing: border-box;
  overflow: visible;
  text-transform: none;
  display: inline-block;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  vertical-align: middle;
  border: 3px solid ${({ outline }) => outline ? "#0a2240" : "transparent"};
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  background-color: ${({ outline }) => outline ? "#fff" : "#0a2240"};
  padding: 5px 0px;
  width: 150px;
  color: ${({ outline }) => outline ? "#0a2240" : "#fff"};
  cursor: pointer;
  width: 200px;

  @media (max-width: 578px) {
    width: 150px;
    font-size: 16px;
  }
`